import { useEffect, useState } from 'react';
import { Card, Row, Col, Radio, Table } from 'antd';
import { Link } from 'react-router-dom';
import { api } from '../AppConfig';
import { motion } from 'motion/react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import {Icon} from 'leaflet';
import { useTranslation } from 'react-i18next';
import { getPhoto } from '../utils/ComponentUtils';
import { generateLeagueColsSmall } from '../utils/DataUtils';
import LeagueCard from '../components/LeagueCard';

function FindLeague(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [leagues, setLeagues] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [mobileView, setMobileView] = useState('map');
  const { t } = useTranslation();

  const MapRecenter= ({ lat, lng, zoomLevel }) => {
    const map = useMap();
  
    useEffect(() => {
      // Fly to that coordinates and set new zoom level
      map.setView([lat, lng], zoomLevel );
    }, [lat, lng]);
    return null;
  
  };

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  
  useEffect(() => {
      fetch(api.leagues().list({'active': true}).href)
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          let fltrRes = result.payLoad.filter(function( obj ) {
            return obj.leagueName !== 'LPI';
          });
          setLeagues(fltrRes);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, [props])

  const onMarkerClick = (event, league) => {  
    // event.preventDefault();
    setSelectedLeague(league);
  }

  const isMobile = width <= 768;

  // TODO: change the center of the map and the zoom level when Philippines announces the affiliation with LPI
  // <MapContainer center={[37.39854535837463, 64.82883885177046]} zoom={3} style={{ height: '80vh', width: '100%', borderRadius: '8px' }}>
  <MapContainer center={[50.37052, 9.73322]} zoom={4} style={{ height: '80vh', width: '100%', borderRadius: '8px' }}></MapContainer>
  if  (isMobile) {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <h1>
          {t('leagues.find').toUpperCase()}
        </h1>
        <Radio.Group
          block
          options={[
            { label: t('leagues.mapView'), value: 'map' },
            { label: t('leagues.listView'), value: 'list' },
          ]}
          onChange={(e) => setMobileView(e.target.value)}
          defaultValue={mobileView}
          optionType="button"
          buttonStyle="solid"
          style={{ marginBottom: '20px' }}
        />
        { mobileView === 'map' ? (
          <div style={{ height: '80vh', width: '100%', borderRadius: '8px' }}>
            <MapContainer center={[37.39854535837463, 64.82883885177046]} zoom={3} style={{ height: '80vh', width: '100%', borderRadius: '8px' }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {
                leagues.map(league => {
                  if (league.locations && league.locations.length > 0) {
                    return league.locations.map(location => (
                      <Marker 
                        key={location.id} 
                        position={[location.longitude, location.latitude]} 
                        icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})} 
                        eventHandlers={{ click: (event) => onMarkerClick(event, league) }}
                      >
                        <Popup>
                          <Link to={`/leagues/${league.id}`}>
                            <b>Pauper League {league.leagueName}</b>
                            <br />
                            {location.name}
                            <br />
                            {location.address}
                            </Link>
                        </Popup>
                    </Marker>
                  ))
                } else {
                    return <div></div>;
                }
              } 
            )}
            </MapContainer>
          </div>
        ) : (
          <Row justify="center" style={{ marginBottom: '20px' }}>
            <Card style={{ 'width': '100%' }} >
              <Table
                columns={generateLeagueColsSmall(t)} 
                dataSource={leagues} 
                pagination={false} 
                loading={!isLoaded}
                size="small"
              />
            </Card>
          </Row> 
        )}
      </motion.div>
    );
  }
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <h1>
        {t('leagues.find').toUpperCase()}
      </h1>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={24} md={24} lg={15} xl={15} >
          <MapContainer center={[37.39854535837463, 64.82883885177046]} zoom={3} style={{ height: '80vh', width: '100%', borderRadius: '8px' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {
                leagues.map(league => {
                  if (league.locations && league.locations.length > 0) {
                    return league.locations.map(location => (
                      <Marker 
                        key={location.id} 
                        position={[location.longitude, location.latitude]} 
                        icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})} 
                        eventHandlers={{ click: (event) => onMarkerClick(event, league) }}
                      >
                        <Popup>
                          <b>Pauper League {league.leagueName}</b>
                          <br />
                          {location.name}
                        <br />
                        {location.address}
                      </Popup>
                    </Marker>
                  ))
                } else {
                    return <div></div>;
                }
              } 
            )}
          </MapContainer>
        </Col>
        <Col xs={24} sm={24} md={24} lg={9} xl={9}>
          <Row justify="center" style={{ marginBottom: '10px' }}>
             <LeagueCard selectedLeague={selectedLeague}/>
          </Row>
          <Row justify="center">
            <Card style={{ 'width': '100%', height: '50vh' }} >
            <Table
              columns={generateLeagueColsSmall(t)} 
              dataSource={leagues} 
              pagination={false} 
              loading={!isLoaded}
              size="small"
              scroll={{ y: '37vh' }}
            />
            </Card>
          </Row>
        </Col>
      </Row>
      {/*
      <p>
        <b>Props keys:</b> {JSON.stringify(Object.keys(props))}
      </p>
      <p>
        <b>Props:</b>
      </p>
      <pre style={{ width: '100%' }}>{JSON.stringify(props, null, 2)}</pre>
      */}
    </motion.div>
  );
}

export default FindLeague;